import validate from "/usr/src/app/content/n3-promos-17cb3020-d604-412a-8af2-07ef9b564307/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-promos-17cb3020-d604-412a-8af2-07ef9b564307/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}